import React, { FC } from 'react';
import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import { receivingNewBookingsAllPharmacies } from 'src/utils/links';
import { generateComment } from '../utils';

const CreationOfTestReservation: FC = () => {
  return (
    <div>
      <p className="mb-1 fs-body-bold">Створення тестового бронювання</p>
      <p className="mb-1">
        <span className="fs-body-bold">POST </span>
        <NavigationLink
          passClassName="underline "
          href={receivingNewBookingsAllPharmacies}
        >
          {receivingNewBookingsAllPharmacies}
        </NavigationLink>
      </p>
      <p className="mb-1">Request:</p>
      <pre>
        <code>
          &#123;
          <p className="indent-6">
            &quot;userPhone&quot;: &quot;380999352287&quot;,{' '}
            {generateComment('телефон клієнта')}
          </p>
          <p className="indent-6">
            &quot;branchCode&quot;: &quot;123456&quot;,{' '}
            {generateComment('код аптеки')}
          </p>
          <p className="indent-6">&quot;items&quot;: &#91; </p>
          <p className="indent-10">&#123;</p>
          <p className="indent-12">
            &quot;restCode&quot;: &quot;67890&quot;,{' '}
            {generateComment('код товару')}
          </p>
          <p className="indent-12">
            &quot;quantity&quot;: 10,{' '}
            {generateComment('кількість пачок товару')}
          </p>
          <p className="indent-12">
            &quot;price&quot;: 9.99 {generateComment('ціна товару')}
          </p>
          <p className="indent-10">&#125;</p>
          <p className="indent-8">&#93;</p>
          &#125;
        </code>
      </pre>
    </div>
  );
};

export default CreationOfTestReservation;
